import { createFileRoute } from "@tanstack/react-router"
import { DeviceTypeDetail } from "@/components/sensory"

export const Route = createFileRoute("/sensory/device-types/$deviceTypeNumber")({
  staticData: {
    title: 'Device Type Detail',
    isSecured: true,
  },
  component: DeviceTypeDetailPage,
})

function DeviceTypeDetailPage() {
  const { deviceTypeNumber } = Route.useParams()

  return (
    <div className="p-6">
      <DeviceTypeDetail deviceTypeNumber={parseInt(deviceTypeNumber)} />
    </div>
  )
}
